// @flow
// $FlowFixMe
import * as Sentry from '@sentry/browser'

const handleError = (error: Object | string) => {
  process.env.NODE_ENV !== 'development' && captureWithSentry(error)
}

export const captureWithSentry = (error: Object | string) => {
  if (error instanceof Error) {
    Sentry.captureException(error)
  } else if (typeof error === 'object') {
    const err = new Error(error.message || 'No Error Message')
    err.name = error.code ? `Payment Error : ${error.code}` : error.name || err.name
    err.message = error.message || err.message

    Sentry.captureException(err)
  } else {
    Sentry.captureMessage(error)
  }
}
export default handleError



// WEBPACK FOOTER //
// ./src/helpers/handle-errors.js